import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';
import { IsDefinedNotEmptyPipe } from '@softline/ui-core';

@Component({
  selector: 'soft-field-ok-geschaeftsfall-list-view',
  imports: [IsDefinedNotEmptyPipe],
  templateUrl: './geschaeftsfall.list-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeschaeftsfallListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
